// extracted by mini-css-extract-plugin
export default {"wrap":"BodyTooltip_wrap__bOrpu","title":"BodyTooltip_title__cvvxM","notifWrap":"BodyTooltip_notifWrap__+zJ68","name":"BodyTooltip_name__jeryS","icon":"BodyTooltip_icon__3qIFx"};